import React, { useEffect, useState } from "react";
import http from "../services/http";
import StatisticNavBtn from "../components/StatisticNavBtn";
import Loading from "../components/Loading";

const StatisticSupplierList = () => {
  const [supplierList, setSupplierList] = useState([]);
  const [isLoading, setLoading] = useState(false);

  useEffect(() => {
    const fetchSupplierList = async () => {
      setLoading(true);
      try {
        const response = await http.get("auth/supplier/list");
        if (response) {
          setSupplierList(response.supplierList);
        }
      } catch (error) {
        console.log(error);
      }
      setLoading(false);
    };

    fetchSupplierList();
  }, []);

  return (
    <div className="w-full">
      {isLoading && <Loading />}
      <div className="mx-10 mt-10 text-5xl font-bold">各廠商支出統計</div>
      <div className="flex flex-wrap">
        {supplierList.map((s) => (
          <StatisticNavBtn
            key={s.id}
            content={s.name}
            href={`/statistic/supplier/${s.id}`}
          />
        ))}
      </div>
    </div>
  );
};

export default StatisticSupplierList;
